module.exports = __webpack_public_path__ + "static/media/ACAC-0048-Letter-of-Appeal-Template-9-20.bbc6119a.docx";